const htmlEscapeMap = {
  '&': {
    // Escape & but at the same time ignore the entities which are originally encoded from WPS
    // https://code.amazon.com/packages/ATVWebPresentationScala/blobs/mainline/--/src/atv/web/data/DVString.scala
    regex: '&(?!(lt;|gt;|amp;|#123;|#125;))',
    replacement: '&amp;'
  },
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#x27;',
  '`': '&#x60;',
}

const space = ' '

export function camelToDataAttrs(obj: any): object {
  return Object.keys(obj).reduce((result, key) =>
    ({[`data-${camelToDashed(key)}`]: obj[key], ...result}), {})
}

export function camelToDashed(text: string): string {
  if (!text || typeof text !== 'string') {
    // TODO CSM logging
    console.warn('function [camelToDashed] : invalid camel case')
    return ''
  }

  return text.replace(/([A-Z])/g, (match) => `-${match.toLowerCase()}`)
}

export const createEscaper:any = (map:any = {}):any => {
  const escaper:any = (match:any):any => {
    const matchConfig = map[match]
    return (typeof matchConfig === 'object' && matchConfig && matchConfig.replacement ? matchConfig.replacement : matchConfig)
  }

  const regexes = Object.keys(map).map(match => {
    const matchConfig = map[match]
    return (typeof matchConfig === 'object' && matchConfig && matchConfig.regex ? matchConfig.regex : match)
  })
  const source = `(?:${regexes.join('|')})`
  const testRegexp = RegExp(source)
  const replaceRegexp = RegExp(source, 'g')

  return (string: any) => {
    const str = typeof string === 'undefined' || string === null ? ''
      : `${string}`
    return testRegexp.test(str) ? str.replace(replaceRegexp, escaper) : str
  }
}

export const htmlEscape:any = createEscaper(htmlEscapeMap)

// TT:0151901306 do not encode/escape hrefs
const attrEscapeMap:any = {
  href: (s:any):any => (s)
}

const escapeAttrValue:any = (attr: string, value: string):any => (
  attrEscapeMap[attr]
    ? attrEscapeMap[attr](value)
    : htmlEscape(value)
)

export const attributesToString = (attrs: any) => {
  if (typeof attrs !== 'object' || attrs === null) {
    return ''
  }

  const attrStrings = Object.keys(attrs).reduce((acc, attr) => (
    [...acc, [htmlEscape(attr), '="', escapeAttrValue(attr, attrs[attr]), '"'].join('') ]
  ), [] as string[])

  return attrStrings.length ? space + attrStrings.join(space) : ''
}

// TODO: support rest parameters
export function firstResult(...args: any[]):any {
  for (let i = 0; i < args.length; i++) {
    const result = (typeof args[i] === 'function') ? args[i]() : false

    if (typeof result !== 'undefined' && result !== false && result !== null) {
      return result
    }
  }
  return undefined
}

// Converting from base 10 to base 36 (https://en.wikipedia.org/wiki/Base36)
// TODO: find a more robust unique ID solution
const baseRadix = 36
export const uniqueId = () => Math.random().toString(baseRadix).slice(2)


export const debounce = (func:any, wait:any) => {
  let timeout:any = null
  return function(this: any, ...args:any[]):any {
    if (timeout !== null) {
      clearTimeout(timeout)
    }
    timeout = setTimeout(() => {
      Reflect.apply(func, this, args)
    }, wait)
  }
}
